(() => {
    const ROOT_SELECTOR = '[data-bundle-builder]';
    const INIT_FLAG = 'bnMobilePackEnhanced';
    const SHIPPING_THRESHOLD = Number(document.querySelector('[data-bn-pack-enhancements]')?.dataset.shippingThreshold || 3500);

    const money = (cents) => `${new Intl.NumberFormat('es-ES', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Math.max(0, cents) / 100)}€`;

    const parseMoney = (value) => {
      const cleaned = String(value || '')
        .replace(/[^0-9,.-]/g, '')
        .replace(/\.(?=\d{3}(?:\D|$))/g, '')
        .replace(',', '.');
      const parsed = Number.parseFloat(cleaned);
      return Number.isFinite(parsed) ? Math.round(parsed * 100) : null;
    };

    const setText = (element, text) => {
      if (element && element.textContent !== text) element.textContent = text;
    };

    const replaceButtonLabel = (button, label) => {
      if (!button) return;
      const textNode = Array.from(button.childNodes).find((node) => node.nodeType === Node.TEXT_NODE);
      if (textNode) {
        const next = `${label} `;
        if (textNode.nodeValue !== next) textNode.nodeValue = next;
      } else if (button.textContent !== label) {
        button.textContent = label;
      }
    };

    const init = () => {
      const root = document.querySelector(ROOT_SELECTOR);
      if (!root || root.hasAttribute('data-bundle-not-ready') || root.dataset[INIT_FLAG] === 'true') return;
      root.dataset[INIT_FLAG] = 'true';

      const summary = root.querySelector('.bn-bundle-summary');
      const toggle = root.querySelector('[data-bundle-summary-toggle]');
      const panel = root.querySelector('[data-bundle-summary-panel]');
      const originalSubmit = root.querySelector('[data-bundle-submit]');
      const mobileCount = root.querySelector('[data-bundle-mobile-count]');
      const mobileTotal = root.querySelector('[data-bundle-mobile-total]');
      const savingSource = root.querySelector('[data-bundle-saving]');
      const compositionSource = root.querySelector('[data-bundle-composition]');
      const totalSource = root.querySelector('[data-bundle-total]');

      let mobileSaving = null;
      let mobileSubmit = null;
      let shipping = null;
      let shippingText = null;
      let shippingFill = null;
      let syncQueued = false;

      if (toggle) {
        const title = toggle.querySelector(':scope > span:first-child');
        if (title) title.textContent = 'TU PACK';

        mobileSaving = document.createElement('span');
        mobileSaving.className = 'bn-bundle-summary__mobile-saving';
        mobileSaving.dataset.bnMobileSaving = '';
        mobileSaving.textContent = 'ELIGE TUS STATES, COLORES Y TALLAS';
        toggle.appendChild(mobileSaving);
      }

      if (summary && toggle && originalSubmit) {
        mobileSubmit = document.createElement('button');
        mobileSubmit.type = 'button';
        mobileSubmit.className = 'bn-bundle-summary__mobile-submit';
        mobileSubmit.dataset.bnMobileSubmit = '';
        mobileSubmit.textContent = 'ELIGE AL MENOS 1 UNIDAD';
        mobileSubmit.addEventListener('click', () => {
          if (!mobileSubmit.disabled) originalSubmit.click();
        });
        toggle.insertAdjacentElement('afterend', mobileSubmit);
      }

      if (panel && originalSubmit) {
        shipping = document.createElement('div');
        shipping.className = 'bn-bundle-summary__shipping';
        shipping.dataset.bnShipping = '';

        shippingText = document.createElement('p');
        shippingText.className = 'bn-bundle-summary__shipping-text';
        shippingText.textContent = `ENVÍO GRATIS EN PENÍNSULA A PARTIR DE ${money(SHIPPING_THRESHOLD)}`;

        const track = document.createElement('span');
        track.className = 'bn-bundle-summary__shipping-track';
        track.setAttribute('aria-hidden', 'true');

        shippingFill = document.createElement('span');
        shippingFill.className = 'bn-bundle-summary__shipping-fill';
        track.appendChild(shippingFill);
        shipping.append(shippingText, track);
        originalSubmit.insertAdjacentElement('beforebegin', shipping);
      }

      const setArrow = () => {
        if (!toggle) return;
        const icon = toggle.querySelector('.bn-bundle-summary__mobile-icon');
        setText(icon, toggle.getAttribute('aria-expanded') === 'true' ? '⌄' : '⌃');
      };

      const syncCard = (card) => {
        const inputs = Array.from(card.querySelectorAll('[data-bundle-card-size]'));
        const button = card.querySelector('[data-bundle-add]');
        if (!inputs.length || !button) {
          replaceButtonLabel(button, button?.disabled ? 'AGOTADO' : 'AÑADIR AL PACK');
          return;
        }

        const explicitSize = card.dataset.bnExplicitSize || '';
        const explicitInput = inputs.find((input) => input.value === explicitSize && !input.disabled);
        const anyAvailable = inputs.some((input) => !input.disabled);

        inputs.forEach((input) => {
          const shouldBeChecked = Boolean(explicitInput && input === explicitInput);
          if (input.checked !== shouldBeChecked) input.checked = shouldBeChecked;
        });

        if (!explicitInput) delete card.dataset.bnExplicitSize;

        const needsSize = anyAvailable && !explicitInput;
        card.classList.toggle('bn-size-pending', needsSize);
        card.classList.toggle('is-sold-out', !anyAvailable);
        card.classList.toggle('is-unavailable', !anyAvailable);
        card.dataset.variantId = explicitInput ? card.dataset.variantId : '';
        card.dataset.available = explicitInput ? 'true' : 'false';

        button.disabled = !explicitInput;
        button.setAttribute('aria-disabled', String(!explicitInput));
        button.classList.toggle('bn-size-required', needsSize);
        replaceButtonLabel(button, !anyAvailable ? 'AGOTADO' : needsSize ? 'SELECCIONA TALLA' : 'AÑADIR AL PACK');
      };

      const syncSummary = () => {
        setArrow();

        const countSource = root.querySelector('[data-bundle-count]');
        const countText = String(countSource?.textContent || mobileCount?.textContent || '0');
        const countMatch = countText.match(/\d+/);
        const count = countMatch ? Number.parseInt(countMatch[0], 10) || 0 : 0;
        const total = parseMoney(totalSource?.textContent || mobileTotal?.textContent);
        const saving = parseMoney(savingSource?.textContent);
        const composition = String(compositionSource?.textContent || '').trim();
        const mode = originalSubmit?.dataset.mode || 'blocked';

        if (mobileSaving) {
          if (count === 0) {
            setText(mobileSaving, 'ELIGE TUS STATES, COLORES Y TALLAS');
          } else if (saving && saving > 0) {
            const applied = composition && composition !== '—' && composition !== 'NO DISPONIBLE'
              ? `${composition.toUpperCase()} APLICADO`
              : 'PACK APLICADO';
            setText(mobileSaving, `${applied} · AHORRAS ${money(saving)}`);
          } else {
            setText(mobileSaving, 'PRECIO TOTAL DE TU SELECCIÓN');
          }
        }

        let ctaLabel = 'ELIGE AL MENOS 1 UNIDAD';
        if (mode === 'submit') ctaLabel = 'AÑADIR PACK AL CARRITO';
        else if (mode === 'viewcart') ctaLabel = 'VER CARRITO';
        else if (mode === 'busy') ctaLabel = originalSubmit.textContent.trim();
        else if (originalSubmit?.textContent) ctaLabel = originalSubmit.textContent.trim();

        if (originalSubmit) {
          if (originalSubmit.textContent !== ctaLabel) originalSubmit.textContent = ctaLabel;
        }
        if (mobileSubmit) {
          setText(mobileSubmit, ctaLabel);
          mobileSubmit.disabled = Boolean(originalSubmit?.disabled);
          mobileSubmit.setAttribute('aria-disabled', String(mobileSubmit.disabled));
        }

        if (shipping && shippingText && shippingFill) {
          const validTotal = total !== null ? total : 0;
          const progress = SHIPPING_THRESHOLD > 0
            ? Math.min(100, Math.max(0, (validTotal / SHIPPING_THRESHOLD) * 100))
            : 100;
          shippingFill.style.width = `${progress}%`;

          if (!count || total === null) {
            setText(shippingText, `ENVÍO GRATIS EN PENÍNSULA A PARTIR DE ${money(SHIPPING_THRESHOLD)}`);
          } else if (validTotal >= SHIPPING_THRESHOLD) {
            setText(shippingText, 'ENVÍO GRATIS EN PENÍNSULA CONSEGUIDO');
          } else {
            setText(shippingText, `TE FALTAN ${money(SHIPPING_THRESHOLD - validTotal)} PARA EL ENVÍO GRATIS EN PENÍNSULA`);
          }
        }
      };

      const syncAll = () => {
        root.querySelectorAll('[data-bundle-product]').forEach(syncCard);
        syncSummary();
      };

      const queueSync = () => {
        if (syncQueued) return;
        syncQueued = true;
        requestAnimationFrame(() => {
          syncQueued = false;
          syncAll();
        });
      };

      root.addEventListener('change', (event) => {
        const input = event.target.closest('[data-bundle-card-size]');
        if (!input) return;
        const card = input.closest('[data-bundle-product]');
        if (!card || input.disabled) return;
        card.dataset.bnExplicitSize = input.value;
        queueSync();
      }, true);

      root.addEventListener('click', (event) => {
        const button = event.target.closest('[data-bundle-add]');
        if (!button) return;
        const card = button.closest('[data-bundle-product]');
        const inputs = Array.from(card?.querySelectorAll('[data-bundle-card-size]') || []);
        if (!inputs.length) return;
        const explicit = inputs.find((input) => input.value === card.dataset.bnExplicitSize && !input.disabled);
        if (explicit) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const firstAvailable = inputs.find((input) => !input.disabled);
        if (firstAvailable) firstAvailable.focus({ preventScroll: true });
        queueSync();
      }, true);

      const observer = new MutationObserver(queueSync);
      observer.observe(root, {
        attributes: true,
        attributeFilter: ['aria-expanded', 'disabled', 'data-mode'],
        childList: true,
        characterData: true,
        subtree: true,
      });

      document.addEventListener('cart:update', queueSync);
      document.addEventListener('discount:update', queueSync);
      window.addEventListener('pageshow', queueSync);
      document.addEventListener('visibilitychange', queueSync);

      const safetyInterval = window.setInterval(syncAll, 1000);
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target || !event.target.contains(root)) return;
        observer.disconnect();
        window.clearInterval(safetyInterval);
      }, { once: true });

      syncAll();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();
